import ButtonLinkElement from "@/app/(site)/_components/GCMolecules/ButtonLinkElement"
import { type ButtonLinkElementType } from "@/types/gc-modules-types"

interface ButtonGroupProps {
    buttons: ButtonLinkElementType[]
    className?: string
}

export default function ButtonGroup({ buttons, className }: ButtonGroupProps) {
    if (!buttons?.length) return null

    return (
        <div className={className}>
            {buttons.map((button, index) => (
                <ButtonLinkElement key={button.text + index} {...button} />
            ))}
        </div>
    )
}
